var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import cx from 'classnames';
import { InputItem } from '../internals/InputItem/InputItem';
import inputStyles from '../internals/Input/Input.module.css';
import styles from './TextArea.module.css';
var InputItemWithTextArea = InputItem;
export var TextArea = function (props) { return (React.createElement(InputItemWithTextArea, __assign({}, props, { renderInputComponent: function (_a) {
        var _b;
        var disabled = _a.disabled, isValid = _a.isValid, className = _a.className, showError = _a.showError, inputRef = _a.inputRef, isSuccessful = _a.isSuccessful, value = _a.value, inputProps = _a.inputProps;
        return (React.createElement("textarea", __assign({ className: cx(inputStyles.input, styles.textArea, className, (_b = {},
                _b[inputStyles.error] = showError,
                _b[inputStyles.disabled] = disabled,
                _b[inputStyles.isSuccessful] = isSuccessful,
                _b)), value: value, disabled: disabled }, inputProps, { ref: inputRef, "aria-invalid": !isValid })));
    } }))); };
//# sourceMappingURL=TextArea.js.map